import axios from "axios";

let API_URI = process.env.REACT_APP_API_BASE_URI || 'http://localhost:1337/api'

const axiosInstance = axios.create({
    baseURL: API_URI
});

export const axiosPrivate = axios.create({
    baseURL: API_URI,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
})

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) =>
        Promise.reject(
            (error.response && error.response.data) || "Something went wrong"
        )
);

export default axiosInstance;
